import secureLocalStorage from "react-secure-storage";

export const getFromCache = (key: string) => {
  const data = secureLocalStorage.getItem(key);
  return data ? JSON.parse(data as string) : null;
};


export const saveToCache = (key: string, data: any) => {
  secureLocalStorage.setItem(key, JSON.stringify(data));
};
